import { useMemo } from 'react'

/**
 * useCompartmentList — splits product.compartments into indoor and outdoor groups.
 *
 * Level 1 hook (pure logic). No state, no effects — only useMemo.
 * Mode-awareness is NOT the hook's concern: whether to show outdoor compartments
 * is decided by CompartmentsList based on compartmentListBehavior from modeRegistry.
 *
 * @param {object}      product          — full product object
 * @param {object|null} compartmentTypes — raw compartments.json from useCatalog().compartments
 * @returns {{
 *   indoorCompartments:  Array,   // sorted by number asc
 *   outdoorCompartments: Array,   // in original data order
 * }}
 */
export function useCompartmentList({ product, compartmentTypes }) {
  const types = compartmentTypes?.compartments_types ?? {}

  return useMemo(() => {
    const allCompartments = Array.isArray(product?.compartments) ? product.compartments : []

    const indoorCompartments = allCompartments
      .filter((c) => types[c.name_cad]?.group !== 'OutdoorSpace')
      .sort((a, b) => a.number - b.number)

    const outdoorCompartments = allCompartments
      .filter((c) => types[c.name_cad]?.group === 'OutdoorSpace')

    return { indoorCompartments, outdoorCompartments }
  }, [product, compartmentTypes]) // eslint-disable-line react-hooks/exhaustive-deps
}
